<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.plots.list_title')}}</h1>
    </div>
    <div class="content">
      <div>
        <div>
          <div>
            <div class="mb-30 action-panel flex items-center wrapper-x-40">
              <div
                v-if="licensed"
                class="action-panel-buttons"
              >
                <router-link
                  :to="{
                    name: 'add_plot',
                    query: $route.query
                  }"
                  class="btn btn-small btn-green"
                >
                  <span><i class="fas fa-plus"></i></span>
                  <span class="ml-2">{{ $t('main.button_add') }}</span>
                </router-link>
                <button
                  class="btn btn-small btn-red"
                  @click="
                    $store.dispatch('plots/remove', deletes);
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-times"></i></span>
                  <span class="ml-2">{{ $t('main.button_delete') }}</span>
                </button>
                <button
                  class="btn btn-small btn-default"
                  @click="
                    $store.dispatch('plots/block', { deletes, status: 0 });
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-times"></i></span>
                  <span class="ml-2">{{ $t('main.button_block') }}</span>
                </button>
                <button
                  class="btn btn-small btn-default"
                  @click="
                    $store.dispatch('plots/block', { deletes, status: 1 });
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-check"></i></span>
                  <span class="ml-2">{{ $t('main.button_unblock') }}</span>
                </button>
              </div>
            </div>

            <div
              class="element-list table-list-wrapper wrapper-x-40"
              v-if="plots"
            >
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        @change="changeCheck"
                      />
                    </th>
                    <th class="image-name">{{ $t('main.tab_list') }}:</th>
                    <th class="by-default whitespace-nowrap">{{$t('main.by_default')}}:</th>
                    <th class="status">{{ $t('main.column_status') }}:</th>
                    <th class="article">{{ $t('main.sizes') }}:</th>
                    <th class="id">ID:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="plot in plots"
                    :key="plot.plot_id"
                  >
                    <td>
                      <input
                        type="checkbox"
                        ref="checkDeletes"
                        :value="plot.plot_id"
                        v-model="deletes"
                      />
                    </td>
                    <td class="name">
                      <router-link :to="{
                          name: 'edit_plot',
                          params: {
                            plot_id: plot.plot_id,
                          },
                          query: $route.query
                        }">
                        {{ plot.name }}
                      </router-link>
                    </td>
                    <td class="by-default text-center">
                      <span
                        class="text-red-500"
                        v-if="plot.is_default"
                      ><i class="fa fa-star"></i></span>
                      <span
                        class="text-gray-500"
                        v-else
                      ><i class="fa fa-star"></i></span>
                    </td>
                    <td class="status">
                      <button
                        @click="$store.dispatch('plots/block', { deletes: [plot.plot_id], status: 0 })"
                        class="text-green-500"
                        :title="$t('main.active')"
                        v-if="plot.status"
                      ><i class="fas fa-check"></i></button>
                      <button
                        @click="$store.dispatch('plots/block', { deletes: [plot.plot_id], status: 1 })"
                        class="text-red-500"
                        :title="$t('main.not_active')"
                        v-else
                      ><i class="fa fa-lock"></i></button>
                    </td>
                    <td class="size whitespace-nowrap">
                      {{ plot.size }}
                    </td>
                    <td class="id">{{ plot.plot_id }}</td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="per_page"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationBar from "../../../components/Admin/PaginationBar.vue";

export default {
  name: "List",
  components: { PaginationBar },
  data() {
    return {
      deletes: [],
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    plots() {
      return this.$store.state.plots.plots;
    },
    meta() {
      return this.$store.state.plots.meta;
    },
    page() {
      return this.$store.state.plots.page;
    },
    per_page() {
      return this.$store.state.plots.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  created() {
    this.receiveQuery();
  },
  methods: {
    receiveQuery() {
      if (Object.hasOwnProperty.call(this.$route.query, "perPage")) {
        this.$store.dispatch("plots/setPerPage", this.$route.query.perPage);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "page")) {
        this.$store.dispatch("plots/setPage", this.$route.query.page);
      }
      this.$store.dispatch("plots/fetch");
    },

    setPage(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },

    setPerPage(perPage) {
      const query = {
        ...this.$route.query,
        perPage,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
  },
};
</script>
<style scoped>
.action-panel-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
